export default class FeaturedIn{
    constructor(element){
        this.element = document.querySelector(element);
        if(!this.element) return;
        this.logos = document.querySelectorAll('.featuredIn__logo');
        this.logosWithCurrentLocale = [];
        this.logosWithEnglishLocale = [];
        this.logosWithoutEnglishVariant = [];
        this.init();
        this.bindEvents();
    }
    init(){
        this.logos.forEach((logo)=>{
            if(logo.dataset.locale.includes(this.element.dataset.currentlocale)){
                this.logosWithCurrentLocale.push(logo);
            } 
        })
        this.element.innerText = '';
        this.logosWithCurrentLocale.forEach(item=>{
            if(item.href !='javascript:void(0)'){item.children[0].classList.add('hoverable')};
            this.element.append(item);
        })
        if(this.element.children.length < 4){
            
            this.element.classList.add('featuredIn__centered')
        } 
        this.element.classList.add('featuredIn--loaded');
    }
    
    bindEvents(){}
}